import { cn } from '@repo/ui/lib/utils'
import type { ElementType, FunctionComponent, PropsWithChildren } from 'react'

interface Props {
  className?: string
  as?: ElementType
}

const Prose: FunctionComponent<PropsWithChildren<Props>> = ({ className, as = 'div', children }) => {
  const Type = as

  return (
    <Type
      className={cn(
        'prose prose-neutral prose-headings:font-normal prose-headings:uppercase prose-headings:mt-[2.5em] prose-h3:text-base prose-h4:text-base prose-h5:text-base prose-hr:my-4 max-w-none text-base text-current',
        className,
      )}
    >
      {children}
    </Type>
  )
}

export default Prose
